var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 77,
    viewBox: "0 0 74 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.9043,
    cy: 38.475,
    rx: 36.5,
    ry: 38.325,
    fill: "white",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.2418 34.8471L27.7243 14.6024C27.1929 14.2608 26.5843 14.0743 25.9613 14.0622C25.3384 14.05 24.7236 14.2128 24.1805 14.5335C23.6427 14.8493 23.1946 15.3098 22.8824 15.8677C22.5702 16.4256 22.4052 17.0607 22.4043 17.7078V58.1925C22.4083 59.1631 22.7793 60.0924 23.4356 60.7759C24.0919 61.4594 24.9799 61.8413 25.9043 61.8377C26.5495 61.8374 27.1822 61.6506 27.733 61.2979L59.2418 41.0532C59.7483 40.7291 60.1668 40.2736 60.4573 39.7306C60.7477 39.1876 60.9003 38.5753 60.9003 37.9525C60.9003 37.3297 60.7477 36.7173 60.4573 36.1743C60.1668 35.6313 59.7483 35.1758 59.2418 34.8517V34.8471ZM25.9043 58.1489V17.7377L57.3671 37.9502L25.9043 58.1489Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.5d279538.svg";
export { ForwardRef as ReactComponent };